// import React from "react";
// import ReactDOM from "react-dom/client";
// import './index.css';
// import reportWebVitals from "./reportWebVitals";
// import InnspireTripPlanner from "./InnspireTripPlanner";


// export let gConfig = {};

// export const config = (conf = {}) => {
//   gConfig = conf;
// };

// export const TripPlanner = {
//   render: async function (args = {}) {
//     console.log("executing trip planner=============>", args,process.env.REACT_APP_VERSION);
    
//     try {
//       let elem;
//       if (args.selector) {
//         elem = document.getElementById(args.selector);
//         if (!elem) {
//           throw new Error(`Element with id "${args.selector}" not found`);
//         }
//       } 
//       else {
//         elem = document.createElement("div");
//         elem.setAttribute("id", "trip-planner-container");
        
//         const app = document.querySelector(".App");
//         if (app) {
//           app.appendChild(elem);
//         } else {
//           if (!document.body) {
//             throw new Error("Document body not found. Ensure the script runs after DOM load");
//           }
//           document.body.appendChild(elem);
//         }
//       }

//       if (elem._reactRoot) {
//         console.warn("React root already exists for this element. Unmounting previous instance.");
//         elem._reactRoot.unmount();
//       }

//       const root = ReactDOM.createRoot(elem);
//       elem._reactRoot = root;


//       if(args?.handleGoHome)
//       window.GoBackToParent = args.handleGoHome

//       root.render(
//         <InnspireTripPlanner
//           url={args?.url || window.location.href}
//           {...args}
//         />
//       );

//       return {
//         unmount: () => {
//           root.unmount();
//           elem._reactRoot = null;
//           if (!args.selector) {
//             elem.remove();
//           }
//         }
//       };
//     } catch (error) {
//       console.error("Failed to initialize TripPlanner:", error);
//       throw error;
//     }
//   },

//   isRendered: function(selector = "trip-planner-container") {
//     const elem = document.getElementById(selector);
//     return !!(elem && elem._reactRoot);
//   }
// };


// if (process.env.NODE_ENV === "development") {
//   config({});
//   TripPlanner.render({
//     selector:"root"
//   });
// }


// reportWebVitals();


import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
// import reportWebVitals from './reportWebVitals';
import { HashRouter } from "react-router-dom";
import { createDynamicLink } from './DynamicSrc_link';

const root = ReactDOM.createRoot(document.getElementById('root'));

console.log("current version ========>",process.env.REACT_APP_VERSION)
createDynamicLink()
root.render(
  <React.StrictMode>
    <HashRouter>
    <App />
    </HashRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
